import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';

import SuperAdminLogin from './pages/SuperAdminLogin';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import Customers from './pages/sales/Customers';
import Invoices from './pages/sales/Invoices';
import InvoicePrint from './pages/sales/InvoicePrint';
import DeliveryChallans from './pages/sales/DeliveryChallans';
import ChallanPrint from './pages/sales/ChallanPrint';
import Quotations from './pages/sales/Quotations';
import QuotationPrint from './pages/sales/QuotationPrint';
import Suppliers from './pages/purchase/Suppliers';
import PurchaseOrders from './pages/purchase/PurchaseOrders';
import PurchaseReceipts from './pages/purchase/PurchaseReceipts';
import SupplierPayments from './pages/purchase/SupplierPayments';
import ChartOfAccounts from './pages/accounts/ChartOfAccounts';
import OwnerTransactions from './pages/accounts/OwnerTransactions';
import JournalEntries from './pages/accounts/JournalEntries';
import Vouchers from './pages/accounts/Vouchers';
import Ledger from './pages/accounts/Ledger';
import TrialBalance from './pages/accounts/TrialBalance';
import ProfitLoss from './pages/accounts/ProfitLoss';
import BalanceSheet from './pages/accounts/BalanceSheet';
import CashFlow from './pages/accounts/CashFlow';
import SalesReport from './pages/reports/SalesReport';
import PurchaseReport from './pages/reports/PurchaseReport';
import InventoryReport from './pages/reports/InventoryReport';
import ProfitSummary from './pages/reports/ProfitSummary';
import CashForecast from './pages/reports/CashForecast';
import Profitability from './pages/reports/Profitability';
import AgingReport from './pages/reports/AgingReport';
import QuickSale from './pages/sales/QuickSale';
import Expenses from './pages/Expenses';
import OpeningBalances from './pages/settings/OpeningBalances';
import ComingSoon from './pages/ComingSoon';
import Budget from './pages/Budget';
import RegressionReport from './pages/RegressionReport';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

const SuperAdminRoute = ({ children }) => {
  const token = localStorage.getItem('superAdminToken');
  return token ? children : <Navigate to="/super-admin" />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          
          <Route path="/super-admin" element={<SuperAdminLogin />} />
          <Route
            path="/super-admin/dashboard"
            element={
              <SuperAdminRoute>
                <SuperAdminDashboard />
              </SuperAdminRoute>
            }
          />
          
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/inventory"
            element={
              <PrivateRoute>
                <Inventory />
              </PrivateRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <PrivateRoute>
                <Customers />
              </PrivateRoute>
            }
          />
          <Route
            path="/sales/invoices"
            element={
              <PrivateRoute>
                <Invoices />
              </PrivateRoute>
            }
          />
          <Route
            path="/sales/invoices/:id/print"
            element={
              <PrivateRoute>
                <InvoicePrint />
              </PrivateRoute>
            }
          />
          <Route
            path="/sales/delivery-challans"
            element={
              <PrivateRoute>
                <DeliveryChallans />
              </PrivateRoute>
            }
          />
          <Route
            path="/sales/delivery-challans/:id/print"
            element={
              <PrivateRoute>
                <ChallanPrint />
              </PrivateRoute>
            }
          />
          <Route
            path="/sales/quotations"
            element={
              <PrivateRoute>
                <Quotations />
              </PrivateRoute>
            }
          />
          <Route
            path="/sales/quotations/:id/print"
            element={
              <PrivateRoute>
                <QuotationPrint />
              </PrivateRoute>
            }
          />
          <Route
            path="/sales"
            element={
              <PrivateRoute>
                <ComingSoon module="sales" />
              </PrivateRoute>
            }
          />
          <Route
            path="/purchase"
            element={
              <PrivateRoute>
                <PurchaseOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/purchase/suppliers"
            element={
              <PrivateRoute>
                <Suppliers />
              </PrivateRoute>
            }
          />
          <Route
            path="/purchase/orders"
            element={
              <PrivateRoute>
                <PurchaseOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/purchase/receipts"
            element={
              <PrivateRoute>
                <PurchaseReceipts />
              </PrivateRoute>
            }
          />
          <Route
            path="/purchase/payments"
            element={
              <PrivateRoute>
                <SupplierPayments />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts"
            element={
              <PrivateRoute>
                <ChartOfAccounts />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts/chart"
            element={
              <PrivateRoute>
                <ChartOfAccounts />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts/journal"
            element={
              <PrivateRoute>
                <JournalEntries />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts/vouchers"
            element={
              <PrivateRoute>
                <Vouchers />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts/ledger"
            element={
              <PrivateRoute>
                <Ledger />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts/trial-balance"
            element={
              <PrivateRoute>
                <TrialBalance />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts/profit-loss"
            element={
              <PrivateRoute>
                <ProfitLoss />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts/balance-sheet"
            element={
              <PrivateRoute>
                <BalanceSheet />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/accounts/cash-flow"
            element={
              <PrivateRoute>
                <CashFlow />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/capital"
            element={
              <PrivateRoute>
                <OwnerTransactions />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/reports/sales"
            element={
              <PrivateRoute>
                <SalesReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/reports/purchase"
            element={
              <PrivateRoute>
                <PurchaseReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/reports/inventory"
            element={
              <PrivateRoute>
                <InventoryReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/reports/profit"
            element={
              <PrivateRoute>
                <ProfitSummary />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/reports/cash-forecast"
            element={
              <PrivateRoute>
                <CashForecast />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/reports/profitability"
            element={
              <PrivateRoute>
                <Profitability />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/reports/aging"
            element={
              <PrivateRoute>
                <AgingReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/reports/regression"
            element={
              <PrivateRoute>
                <RegressionReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/sales/quick-sale"
            element={
              <PrivateRoute>
                <QuickSale />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/expenses"
            element={
              <PrivateRoute>
                <Expenses />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/settings/opening-balances"
            element={
              <PrivateRoute>
                <OpeningBalances />
              </PrivateRoute>
            }
          />
          <Route
            path="/budget"
            element={
              <PrivateRoute>
                <Budget />
              </PrivateRoute>
            }
          />
          <Route
            path="/hr"
            element={
              <PrivateRoute>
                <ComingSoon module="HR" />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <ComingSoon module="reports" />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <ComingSoon module="settings" />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
